import React from "react";
import {
  Form,
  Divider,
} from "antd";

const Item = Form.Item;

function getSetItems(extendData = {}){
  return <>
    <Divider orientation="left">
      无配置项
    </Divider>
  </>
}

function getDefaultValues(){
  return {}
}

//推荐数据格式
function getDemoCode(){
  return `
    任意符合JSON格式的数据皆可`
}

export default {
  getSetItems,
  getDefaultValues,
  getDemoCode
}